export enum BrowserStorageType {
	Session,
	Local,
}

export enum UserRole {
	Admin = 'Admin',
	AccountAdmin = 'AccountAdmin',
	User = 'User',
	ReadOnlyAdmin = 'ReadOnlyAdmin',
}

export enum BillingPostageType {
	AutoBuy = 'AutoBuy',
	PurchasePostage = 'PurchasePostage',
}

export enum SnackBarVariants {
	Error = 'error',
	Info = 'info',
	Success = 'success',
}

export enum ProviderEnum {
	GE = 'GE',
	PH = 'PHv2',
}

export enum ShipmentManifestStatusEnum {
	Pending = 'Pending',
	Processed = 'Processed',
	Queued = 'Queued',
	Uploaded = 'Uploaded',
	Accepted = 'Accepted',
	AcceptedWithWarning = 'AcceptedWithWarning',
	Error = 'Error',
	ReadyToReattempt = 'ReadyToReattempt',
	Reattempted = 'Reattempted',
	Rejected = 'Rejected',
}

export enum ShipmentRatingTypeEnum {
	NotRated = 'Not Rated',
	Rated = 'Rated',
}

export enum EventTypeEnum {
	OnLabelGenerate = 'OnLabelGenerate',
	OnLabelRefund = 'OnLabelRefund',
	OnPostagePurchase = 'OnPostagePurchase',
	OnAutoBuyPurchase = 'OnAutoBuyPurchase',
	APVShortPay = 'APVShortPay',
	APVOverPay = 'APVOverPay',
	BillingCredit = 'BillingCredit',
	AdjustmentCredit = 'AdjustmentCredit',
	AdjustmentDebit = 'AdjustmentDebit',
	AdjustmentDebit_AddFund = 'AdjustmentDebit_AddFund',
}

export enum CurrencyEnum {
	USD = 'USD',
}

export enum TransactionTypeEnum {
	Debit = 'Debit',
	Credit = 'Credit',
}

export enum ServiceEnum {}

export enum SpecialServiceExternalEnum {}

export enum LiveAnimalTypeEnum {}

export enum PaymentOptions {
	None = 'None',
	CreditCard = 'Credit Card',
	ACH = 'ACH',
}

export enum PackageTypeEnum {
	Parcel = 'Parcel',
	FlatRateEnvelope = 'FlatRateEnvelope',
	SmallFlatRate = 'SmallFlatRate',
	PaddedFlatRateEnvelope = 'PaddedFlatRateEnvelope',
	RegionalRateBoxB = 'RegionalRateBoxB',
	MediumFlatRateBox = 'MediumFlatRateBox',
	RegionalRateBoxA = 'RegionalRateBoxA',
	LargeFlatRateBox = 'LargeFlatRateBox',
	LegalFlatRateEnvelope = 'LegalFlatRateEnvelope',
	ApoFpoDpoLargeFlatRateBox = 'ApoFpoDpoLargeFlatRateBox',
	SoftPack = 'SoftPack',
}

export enum DimensionTypeEnum {
	cm = 'cm',
	mm = 'mm',
	m = 'm',
	in = 'in',
	ft = 'ft',
	yd = 'yd',
}

export enum WeightUnitEnum {
	oz = 'oz',
	lb = 'lb',
	g = 'g',
	kg = 'kg',
}

export enum AccountLevelEnum {
	Partner = 'Partner',
	Customer = 'Customer',
	Admin = 'Admin',
}

export enum AccountStatusEnum {
	Active = 'Active',
	TnCPending = 'TnCPending',
	Closed = 'Closed',
}

export enum PredefinedFiltersEnum {
	Custom = 'Custom',
	Last7Days = 'Last7Days',
	Last30Days = 'Last30Days',
	MonthToDate = 'MonthToDate',
	QuarterToDate = 'QuarterToDate',
	YearToDate = 'YearToDate',
}

export enum OperationEnum {
	Add = 'Add',
	Update = 'Update',
	Delete = 'Delete',
}

export enum ServiceEnum {
	ALL = 'ALL',
	PriorityMail = 'PriorityMail',
	PriorityMailExpress = 'PriorityMailExpress',
	ParcelSelect = 'ParcelSelect',
	ParcelMailExpressIntl = 'ParcelMailExpressIntl',
	PriorityMailIntl = 'PriorityMailIntl',
	GlobalExpressGuranateed = 'GlobalExpressGuranateed',
	FirstClassIntl = 'FirstClassIntl',
	LibraryMail = 'LibraryMail',
	MediaMail = 'MediaMail',
	BoundPrintedMatter = 'BoundPrintedMatter',
	PriorityMailCubic = 'PriorityMailCubic',
	FirstClass = 'FirstClass',
	Ecommerce = 'Ecommerce',
	'Express10:30DOC' = 'Express10:30DOC',
	'Express10:30' = 'Express10:30',
	'Express12:00DOC' = 'Express12:00DOC',
	'Express12:00' = 'Express12:00',
	'Express9:00DOC' = 'Express9:00DOC',
	'Express9:00' = 'Express9:00',
	'ExpressWorldwide' = 'ExpressWorldwide',
	'GlobalMailBusiness' = 'GlobalMailBusiness',
}

export enum ShipmentRateStatusEnum {
	RatingFailed = 'RatingFailed',
	RatingWithSpecialService = 'RatingWithSpecialService',
	Rating = 'Rating',
}

export enum RatingTypeEnum {
	Weight = 'Weight',
	WeightAndZone = 'WeightAndZone',
	DimensionalWeightAndZone = 'DimensionalWeightAndZone',
	Cubic = 'Cubic',
	NewBlueCubic = 'NewBlueCubic',
	Flat = 'Flat',
	Regional = 'Regional',
}

export enum ShippingStatusEnum {
	PreTransit = 'PreTransit',
	InTransit = 'InTransit',
	Delayed = 'Delayed',
	OutForDelivery = 'OutForDelivery',
	DeliveryFailed = 'DeliveryFailed',
	Delivered = 'Delivered',
	Cancelled = 'Cancelled',
	Other = 'Other',
	ReadyForPickup = 'ReadyForPickup',
	DeliveryAttempt = 'DeliveryAttempt',
}

export enum ContentTypeEnum {
	DOCUMENTS = 'DOCUMENTS',
	GIFT = 'GIFT',
	MERCHANDISE = 'MERCHANDISE',
	RETURN = 'RETURN',
	SAMPLE = 'SAMPLE',
	OTHER = 'OTHER',
	HUMANITARIAN = 'HUMANITARIAN',
	DANGEROUSGOODS = 'DANGEROUSGOODS',
}

export enum EELPFCEnum {
	'NOEEI3037a' = 'NOEEI3037a',
	'NOEEI3036' = 'NOEEI3036',
	'NOEEI3037h' = 'NOEEI3037h',
	'NOEEI3037y' = 'NOEEI3037y',
}

export enum NonDeliveryOptionEnum {
	RETURN = 'RETURN',
	REDIRECT = 'REDIRECT',
	ABANDON = 'ABANDON',
}

export enum RestrictionTypesEnum {
	Quarantine = 'Quarantine',
	'Sanitary Inspection' = 'Sanitary Inspection',
	Phytosanitary = 'Phytosanitary',
	Inspection = 'Inspection',
	Other = 'Other',
}
export enum ButtonTypeEnum {
	Submit = 'submit',
	Button = 'button',
	Reset = 'reset',
}

export enum ButtonColorEnum {
	Inherit = 'inherit',
	Primary = 'primary',
	Secondary = 'secondary',
	Default = 'default',
}

export enum ButtonVariantEnum {
	Text = 'text',
	Outlined = 'outlined',
	Contained = 'contained',
}

export enum ButtonSizeEnum {
	Small = 'small',
	Medium = 'medium',
	Large = 'large',
}

export enum PurchasePostageEnum {
	AutoBuy = 'AutoBuy',
	AddBalance = 'AddBalance',
}

export enum EnableDisableEnum {
	Enabled = 'Enabled',
	Disabled = 'Disabled',
}

export enum CarriersEnum {
	USPSeVS = 'USPS-eVS',
	USPSePostage = 'USPS-ePostage',
	USPSShip = 'USPS-Ship',
	USPSPHv2 = 'USPS-PC-Postage',
	UPSPHv2 = 'UPS',
	DHLExpressPHv2 = 'DHL-Express',
	USPSeVSNative = 'USPS-eVS-Native',
	USPSePostageNative = 'USPS-ePostage-Native',
	USPSeVSWarehouse = 'USPS-eVS-VSCM',
	USPSePostageWarehouse = 'USPS-ePostage-VSCM',
	PBPHv2 = 'PB',
	UPSMI = 'UPSMI',
	FedEx = 'FedEx',
	FedExNative = 'FedEx-Native',
	USPSeVSPostPay = 'USPS-eVS-PostPay',
	USPSePostagePostPay = 'USPS-ePostage-PostPay',
	UPSNative = 'UPS-Native',
}

export enum SCACEnum {
	USPS = 'USPS',
	UPS = 'UPS',
	DHL = 'DHL',
	PB = 'PB',
	FDE = 'FDE',
	LMR = 'LMR',
}

export enum CarrierGroupEnum {
	Group1 = 'Group1',
	Group2 = 'Group2',
	Group3 = 'Group3',
	Group4 = 'Group4',
	Group5 = 'Group5',
}

export enum CarrierPaymentTypeEnum {
	PHv2 = 'PHv2',
	Nexio = 'Nexio',
	Postpaid = 'Postpaid',
}

export enum USPSPaymentAccountTypeEnum {
	EPS = 'EPS',
	Permit = 'Permit',
}

export enum StatusEnum {
	Disabled = 'Disabled',
	Public = 'Public',
}

export enum CarrierStatusEnum {
	Public = 'Public',
	Private = 'Private',
	Disabled = 'Disabled',
}

export enum CarrierAccountStatusEnum {
	Requested = 'Requested',
	Enabled = 'Enabled',
	Disabled = 'Disabled',
	NotEligible = 'NotEligible',
	EnabledWithoutWatermark = 'EnabledWithoutWatermark',
}

export enum CostTypeEnum {
	Base = 'Base',
	Surcharge = 'Surcharge',
	SpecialService = 'SpecialService',
	CreditCardFee = 'CreditCardFee',
	ClientFee = 'ClientFee',
	PartnerFee = 'PartnerFee',
}

export enum AccountSubscriptionEnum {
	Basic = 'Basic',
	Professional = 'Professional',
	Enterprise = 'Enterprise',
	EnterprisePlus = 'Enterprise Plus',
}

export enum LabelTypeEnum {
	Base64 = 'Base64',
	Url = 'Url',
}

export enum LabelFileTypeEnum {
	PDF = 'PDF',

	TIF = 'TIF',

	ZPL = 'ZPL',

	PNG = 'PNG',

	ZPL2 = 'ZPL2',

	JPEG = 'JPEG',
}

export enum ShareSignUpModeEnum {
	URL = 'URL',
	Email = 'Email',
	HTML = 'HTML',
}

export enum SignUpModeEnum {
	Quick = 'Quick',
	Normal = 'Normal',
}

export enum GetTypeEnum {
	ShipmentId = 'ShipmentId',
	TransactionId = 'TransactionId',
	TrackingNumber = 'TrackingNumber',
	Id = 'Id',
}

export enum AdminDownloadFileTypeEnum {
	ManifestDocument = 'ManifestDocument',
	CarrierFile = 'CarrierFile',
}

export enum USPSMIDTypeEnum {
	Outbound = 'Outbound',
	Returns = 'Returns',
}

export enum ReprintLabelPackageSelectionEnum {
	All = 'All',
	Specific = 'Specific',
}

export enum ReCaptchaStatusEnum {
	Enabled = 'Enabled',
	Bypass = 'Bypass',
	Disabled = 'Disabled',
}

export enum MaerskColorPalette {
	// Typography
	Text = '#141414',

	// Primary color
	MaerskBlue = '#42B0D5',

	// Secondary colors
	DarkBlue = '#00243D',
	MidBlue = '#0073AB',
	LightBlue = '#B5E0F5',

	// Accent color (used minimally to draw attention to specific content)
	AccentRed = '#FA6A55',

	// Functional Greys

	UltraDarkGrey = '#545454',
	DarkGrey = '#878787',
	MidGrey = '#CFCFCF',
	LightGrey = '#EDEDED',
	UltraLightGrey = '#F7F7F7',
	BorderGrey = '#BDBDBD',

	// Feedback colors
	SuccessGreen = '#40AB35',
	SuccessGreenLight = '#C5E5C2',
	WarningYellow = '#FFD029',
	WarningYellowLight = '#FFF0BE',
	ErrorRed = '#B80012',
	ErrorRedLight = '#E9B2B7',
	NotificationBorder = '#42B0D5',
	NotificationBackground = '#B5E0F5',

	White = '#FFFFFF',
}

export enum USPSTierSourceEnum {
	Partner = 'Partner',
	Customer = 'Customer',
	NAForPartnerAndAdminAccounts = 'NAForPartnerAndAdminAccounts',
	Default = 'Default',
}

export enum GroundEconomyPickUpCarrierEnum {
	FedExGround = 'FDXG',
	FedExGroundEconomy = 'FXSP',
}

export enum EffectiveDateFilterEnum {
	Today = 'Today',
	All = 'All',
}

export enum RatingModeEnum {
	WithShipment = 'WithShipment',
	WithManifest = 'WithManifest',
	Disabled = 'Disabled',
}

export enum USPSRequestMappingModeEnum {
	Normal = 'Normal',
	HidePhoneEmail = 'HidePhoneEmail',
}

export enum USPSAutoManifestScheduleSourceTypeEnum {
	CarrierAccount = 'CarrierAccount',
	Account = 'Account',
}

export enum USPSAutoManifestScheduleStatusEnum {
	Enabled = 'Enabled',
	Disabled = 'Disabled',
}

export enum USPSAutoManifestScheduleLastExecutionStatusEnum {
	Pending = 'Pending',
	Skipped = 'Skipped',
	Succeeded = 'Succeeded',
	PartiallySucceeded = 'PartiallySucceeded',
	Failed = 'Failed',
}



// WEBPACK FOOTER //
// ./src/app.enum.ts